import React, { Component } from 'react'
import ConfirmDetailsForm from '../tags/ConfirmDetailsForm'
import CalloutBox from '../tags/CalloutBox'
import { getHelperTextForPage, getTooltipsForPage } from '../../services/reservoir'
import { getSonePersonalDetails, getReferences, getStudentProgress, putSonePersonalDetails, postAddressSearch, postValidateAddress } from '../../services/vu'
import { getStepByIndex, getStepIndexByUrl, updateDBStepProgress, updateStepProgress } from '../../helpers/steps'
import { withRouter } from 'react-router-dom'
import { getPermanentAddressFields, getContactAddressFields, isInternationalOnshoreStudent, mergePermanentDetails, mergeContactDetails, stripPhoneNumber, isSameAddress } from '../../helpers/form'
import AddressType from '../../enums/AddressType'
import Loading from '../tags/Loading'
import Country from '../../enums/Country'
import { getCourseId } from '../../helpers/course'
import { differenceInSeconds } from 'date-fns'
import { getLastPageAccessTime } from '../../helpers/gtm'
import { getAttributeCourseStaticInfo } from '../../helpers/enrolment'
import Phone from '../../enums/Phone'
import AddressValidationStatus from '../../../../welcomeSPA/src/enums/AddressValidationStatus'
import ConfirmationModal from '../tags/ConfirmationModal'
import { CustomModal } from '../tags/Modals/Modal'
import AddressMatchTypes from '../../enums/AddressMatchTypes'
import { normalizeWhitespace } from '../../helpers/validation'

const dateFormat = { year: 'numeric', month: 'short', day: 'numeric' }

class ConfirmDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formLoaded: false,
      saving: false,
      form: {
        preferredName: '',
        mobileNumber: '',
        homePhoneNumber: '',
        emailAddress: '',
        permanentCountry: '',
        permanentAddressLine1: '',
        permanentAddressLine2: '',
        permanentAddressLine3: '',
        permanentSuburb: '',
        permanentState: '',
        permanentPostcode: '',
        permanentHasAddressChanged: false,
        insertPermanentAddressManually: false,

        knowsAustralianAddress: "N",
        contactAddressSameAsPermanentAddress: false,
        contactCountry: '',
        contactAddressLine1: '',
        contactAddressLine2: '',
        contactAddressLine3: '',
        contactSuburb: '',
        contactState: '',
        contactPostcode: '',
        contactHasAddressChanged: false,
        insertContactAddressManually: false,
        contactRelationship: '',
        citizenshipCode: '',
        offshoreFlag: ''
      },
      personDetails: {},
      topCallout: '',
      prefilledData: {
        Title: '',
        'Given names': '',
        Surname: '',
        Gender: '',
        'Date of birth': ''
      },
      tooltips: [],
      countryCodes: [],
      emergencyContactOptions: [],
      showInvalidAddressModal: false,
      hasAttemptedToSave: false,
      showConfirmationModal: false,
      addressToConfirm: null,
      pendingSubmission: null,
      hasIgnoredPermanentValidationSuggestion: false,
      hasIgnoredContactValidationSuggestion: false,
      excludedCountries: [{ countryCode: 'YCJ', countryDescription: 'AUSTRALIAN ANTARCTIC TERRITORY' }, { countryCode: 'XTJ', countryDescription: 'AUSTRALIAN EXTERNAL TERRITORIES' }]
    }
  }

  componentDidMount() {
    Promise.all([getHelperTextForPage('Confirm Details'), getTooltipsForPage('Confirm Details'), getReferences(), getSonePersonalDetails()]).then(
      ([helperText, tooltips, { soneCountryCodeList = [], soneEmergencyContactCodeList = [] }, personalDetails]) => {
        this.setState({
          topCallout: helperText.data.length > 0 ? helperText.data[0].attributes.body.value : this.state.topCallout,
          tooltips: tooltips.data,
          countryCodes: soneCountryCodeList,
          emergencyContactOptions: soneEmergencyContactCodeList,
          form: {
            ...this.state.form,
            ...this.mergeStudentDetails(personalDetails, soneCountryCodeList),
            offshoreFlag: getAttributeCourseStaticInfo('isOffshoreFlag')
          },
          formLoaded: true,
          prefilledData: {
            Title: personalDetails.title,
            'Given names': personalDetails.legalFirstName,
            Surname: personalDetails.legalLastName,
            Gender: personalDetails.gender,
            'Date of birth': new Date(personalDetails.dateOfBirth).toLocaleDateString('en-AU', { timeZone: 'Australia/Melbourne' }, dateFormat)
          },
          personDetails: {
            ...personalDetails,
            addresses: personalDetails.addresses.map(address => {
              let keys = Object.keys(address)

              keys.forEach(key => {
                if (address[key] === null) {
                  address[key] = ''
                }
              })
              return address
            })
          }
        })
      }
    )
    this.trackPageView()
  }

  trackPageView = () => {
    getStudentProgress(getCourseId()).then(progress => {
      const processId = progress && progress.id ? progress.id : undefined

      const lastPageAccessTime = getLastPageAccessTime()
      const pageAccessTime = new Date()

      window.dataLayer.push({
        event: 'custom.form.step.view',
        group: 'Enrol',
        processId: processId,
        step: {
          sequence: 2,
          label: 'Confirm your details',
          variation: undefined
        },
        info: {
          time: lastPageAccessTime ? differenceInSeconds(pageAccessTime, new Date(lastPageAccessTime)) : undefined
        },
        data: {
          value: undefined,
          courseId: getCourseId()
        }
      })

      sessionStorage.setItem('LAST_PAGE_ACCESS_TIME', JSON.stringify(pageAccessTime))
    })
  }

  handlePhoneInformation = (phoneNumber, type, isInvalid = false) => {
    let phone = this.state.personDetails.phones.find(phone => phone.phoneType == type)

    return {
      phoneType: type,
      phoneNumber: phoneNumber,
      isInvalid: isInvalid,
      isPreferredSms: isInvalid ? false : phone && phone.isPreferredSms ? phone.isPreferredSms : false,
      isPreferredVoice: isInvalid ? false : phone && phone.isPreferredVoice ? phone.isPreferredVoice : false
    }
  }

  validateExistingAddress = ({ addressLine1 = '', addressLine2 = '', addressLine3 = '', city = '', state = '', postCode = '', country = '' }) => {
    const addressSearch = addressLine1 + ' ' + addressLine2 + ' ' + addressLine3 + ', ' + city + ' ' + state + ' ' + postCode

    return postAddressSearch(country, addressSearch).then(({ confidence, suggestions }) => {
      if (confidence === AddressMatchTypes.VERIFIED_MATCH && suggestions.length === 1) {
        return suggestions[0]
      }
      return null
    })
  }

  handleSubmit = ({form, valid, errors}) => {
    const { hasAttemptedToSave, hasIgnoredPermanentValidationSuggestion, hasIgnoredContactValidationSuggestion, excludedCountries } = this.state

    const isPermanentExcluded = excludedCountries.some(excludedCountry => excludedCountry.countryCode === form.permanentCountry)
    const isContactExcluded = excludedCountries.some(excludedCountry => excludedCountry.countryCode === form.contactCountry)

    const isPermanentAddressValid = form.permanentValidationStatus === AddressValidationStatus.VALIDATED
    const isContactAddressValid = form.contactValidationStatus === AddressValidationStatus.VALIDATED

    const permanentAddressFields = getPermanentAddressFields(form)
    const contactAddressFields = getContactAddressFields(form)
    const previousPermanentAddressFields = getPermanentAddressFields(this.state.form)
    const previousContactAddressFields = getContactAddressFields(this.state.form)

    const isSameContactAddress = isSameAddress(previousContactAddressFields, contactAddressFields)
    const isSamePermanentAddress = isSameAddress(previousPermanentAddressFields, permanentAddressFields)

    const addressesChanged =
      !isSameContactAddress ||
      !isSamePermanentAddress ||
      form.insertPermanentAddressManually !== this.state.form.insertPermanentAddressManually ||
      form.insertContactAddressManually !== this.state.form.insertContactAddressManually

    if (addressesChanged) {
      this.setState({
        hasIgnoredPermanentValidationSuggestion: false,
        hasIgnoredContactValidationSuggestion: false,
        hasAttemptedToSave: false
      })
    }

    const promises = []
    let foundAddressToConfirm = null

    if (!isPermanentExcluded && ((!isPermanentAddressValid && !hasIgnoredPermanentValidationSuggestion) || (!isSamePermanentAddress && !isPermanentAddressValid))) {

      promises.push(
        this.validateExistingAddress(permanentAddressFields).then(result => {
          if (result) {
            foundAddressToConfirm = { type: 'permanent', searchResult: result }
            return true
          }
          return false
        })
      )
    }

    if (
      !isContactExcluded && this.state.form.knowsAustralianAddress === "Y" &&
      ((!isContactAddressValid && !form.contactAddressSameAsPermanentAddress && !hasIgnoredContactValidationSuggestion) ||
      (!isSameContactAddress && !isContactAddressValid && !form.contactAddressSameAsPermanentAddress))
    ) {
      promises.push(
        this.validateExistingAddress(contactAddressFields).then(result => {
          if (result) {
            foundAddressToConfirm = { type: 'contact', searchResult: result }
            return true
          }
          return false
        })
      )
    }

    Promise.all(promises).then(results => {
      if (foundAddressToConfirm) {
        this.setState({
          addressToConfirm: foundAddressToConfirm,
          showConfirmationModal: true,
          pendingSubmission: { form, valid, errors },
          form: { ...form }
        })
        return
      }

      if (valid) {
        const shouldShowWarning = (!isPermanentExcluded && !isPermanentAddressValid) || (!form.contactAddressSameAsPermanentAddress && !isContactExcluded && !isContactAddressValid)

        if (!shouldShowWarning || (hasAttemptedToSave && !addressesChanged)) {
          this.handlePutRequest(form)
        } else {
          this.setState({
            showInvalidAddressModal: true,
            hasAttemptedToSave: true,
            form: form
          })
        }
      } else {
        const failedFieldName = Object.keys(errors).find(errorKey => {
          return errors[errorKey].length > 0
        })

        if (failedFieldName) {
          const failedField = window.document.querySelector(`[name=${failedFieldName}]`)
          if (failedField && failedField.scrollIntoView) {
            failedField.scrollIntoView({
              behavior: 'smooth'
            })
          } else {
            window.scrollTo(0, 0)
          }
        } else {
          window.scrollTo(0, 0)
        }
      }
    })
  }

  handlePutRequest = form => {
    let originalPersonalDetails = this.state.personDetails
    let mobileContact = originalPersonalDetails.phones.find(phone => phone.phoneType == Phone.MOBILE);
    let homeContact = originalPersonalDetails.phones.find(phone => phone.phoneType == Phone.HOME);

    let homePhoneNumberStripped = stripPhoneNumber(form.homePhoneNumber)
    let contactMobilePhoneNumberStripped = stripPhoneNumber(form.mobileNumber)

    let homePhoneInvalid = homePhoneNumberStripped === "" ? true : false

    let homePhone = homePhoneInvalid ? 
      (homeContact && homeContact.phoneNumber) ? 
        this.handlePhoneInformation(homeContact.phoneNumber, Phone.HOME, homePhoneInvalid) 
        : this.handlePhoneInformation(null, Phone.HOME, homePhoneInvalid)  
      : this.handlePhoneInformation(homePhoneNumberStripped, Phone.HOME, homePhoneInvalid);

    let mobilePhone = (mobileContact && mobileContact.phoneNumber === contactMobilePhoneNumberStripped) ?
      mobileContact : 
      this.handlePhoneInformation(contactMobilePhoneNumberStripped, Phone.MOBILE, false);
    
    let guardianLvls = this.state.personDetails.studentGuardiansEduLvl.filter(({ sequenceNumber }) => sequenceNumber === 1 || sequenceNumber === 2)
    let addresses = this.reconcileAddresses(this.state.personDetails.addresses, form)

    let chosenFirstName = form.chosenFirstName ? form.chosenFirstName : ""
    let chosenLastName = form.chosenLastName ? form.chosenLastName : ""

    let newPersonalDetails = {
      ...this.state.personDetails,
      chosenFirstName: chosenFirstName,
      chosenLastName: chosenLastName,
      preferredName: normalizeWhitespace(form.preferredName),
      chosenPronouns: form.chosenPronouns,
      chosenAffirmedGender: form.chosenAffirmedGender,
      contactPersonalEmail: form.emailAddress,
      studentGuardiansEduLvl: guardianLvls,
      emergencyContactName: normalizeWhitespace(form.contactName),
      emergencyContactMobilePhone: form.contactNumber,
      emergencyContactRelationshipCode: form.contactRelationship,
      phones : [mobilePhone, homePhone].filter(contact => contact.phoneNumber !== null),
      addresses: addresses
    }

    this.setState({
      saving: true
    })

    putSonePersonalDetails(newPersonalDetails)
    .then(() => {
      this.handleSuccessfulSubmission()
    })
    .catch(() => {
      this.handleErrorSubmission('Unable to save personal details.')
    })

  }

  handleModalConfirm = () => {
    const { addressToConfirm, form, pendingSubmission } = this.state;
  
    this.setState({ showConfirmationModal: false }, () => {
      postValidateAddress(
        addressToConfirm.searchResult.globalAddressKey,
        addressToConfirm.type === AddressType.Permanent ? pendingSubmission.form.permanentCountry: pendingSubmission.form.contactCountry
      ).then(validatedAddress => {
          if (validatedAddress) {
            const updatedAddress = this.handleAddressValidation(validatedAddress, addressToConfirm.type);
            
            // Create the updated form state
            const updatedForm = { ...form, ...updatedAddress };
            
            // Create updated pending submission
            const updatedPendingSubmission = {
              ...pendingSubmission,
              form: { ...pendingSubmission.form, ...updatedAddress }
            };
  
            return new Promise(resolve => {
              this.setState({
                form: updatedForm,
                pendingSubmission: updatedPendingSubmission,
                addressToConfirm: null
              }, () => {
                if (this.confirmDetailsFormRef && this.confirmDetailsFormRef.updateState) {
                  this.confirmDetailsFormRef.updateState(this.state.form);
                }
                resolve(updatedPendingSubmission);
              });
            });
          }
        })
        .then(updatedPendingSubmission => {
          if (updatedPendingSubmission) {
            this.handleSubmit(updatedPendingSubmission);
          }
        });
    });
  };

  handleModalCancel = addressType => {
    const { 
      pendingSubmission, 
      hasIgnoredContactValidationSuggestion, 
      hasIgnoredPermanentValidationSuggestion 
    } = this.state;
  
    const updatedState = {
      showConfirmationModal: false,
      addressToConfirm: null,
      form: pendingSubmission ? pendingSubmission.form : this.state.form,
      hasIgnoredPermanentValidationSuggestion: 
        addressType === 'permanent' ? true : hasIgnoredPermanentValidationSuggestion,
      hasIgnoredContactValidationSuggestion: 
        addressType === 'contact' ? true : hasIgnoredContactValidationSuggestion,
    };
  
    // If we have a pending submission, update it with the ignored flags
    if (pendingSubmission) {
      updatedState.pendingSubmission = {
        ...pendingSubmission,
        form: updatedState.form,
        hasIgnoredPermanentValidationSuggestion: updatedState.hasIgnoredPermanentValidationSuggestion,
        hasIgnoredContactValidationSuggestion: updatedState.hasIgnoredContactValidationSuggestion
      };
    }
  
    this.setState(updatedState, () => {
      document.body.style.overflowY = 'auto';
      document.body.style.overflowX = 'hidden';
      document.documentElement.style.overflowY = 'auto';
      document.documentElement.style.overflowX = 'hidden';
  
      if (pendingSubmission) {
        // Use the updated pending submission from state
        this.handleSubmit(this.state.pendingSubmission);
      }
    });
  };

  handleAddressValidation = ({ addressLine1, addressLine2, addressLine3, city, state, postCode, country, longitude, latitude, verificationDate, validationStatus }, type) => {
    if (type === 'permanent') {
      return {
        permanentAddressLine1: addressLine1,
        permanentAddressLine2: addressLine2,
        permanentAddressLine3: addressLine3,
        permanentSuburb: city,
        permanentState: state,
        permanentPostcode: postCode,
        permanentLatitude: longitude || 0,
        permanentLongitude: latitude || 0,
        permanentVerificationDate: verificationDate || '',
        permanentValidationStatus: validationStatus,
        insertPermanentAddressManually: false
      }
    } else {
      return {
        contactAddressLine1: addressLine1,
        contactAddressLine2: addressLine2,
        contactAddressLine3: addressLine3,
        contactSuburb: city,
        contactState: state,
        contactPostcode: postCode,
        contactLatitude: longitude || 0,
        contactLongitude: latitude || 0,
        contactVerificationDate: verificationDate || '',
        contactValidationStatus: validationStatus,
        insertContactAddressManually: false
      }
    }
  }

  handleErrorSubmission = errorMessage => {
    this.setState({
      saving: false
    })

    alert(errorMessage)
  }

  handleSuccessfulSubmission = () => {
    this.setState({
      saving: false
    })

    this.progressForm()
  }

  progressForm = () => {
    const currentStepIndex = getStepIndexByUrl(this.props.location.pathname)

    updateStepProgress(currentStepIndex)
    updateDBStepProgress(currentStepIndex)

    this.props.history.push(getStepByIndex(currentStepIndex + 1).url)
  }

  invalidateAddress = address => {
    return {
      ...address,
      isInvalid: true,
      isPreferred: false
    }
  }

  createAddress = (addressType, form) => {
    return {
      ...form,
      addressType: addressType
    }
  }

  mapToAddress = (address, form, isPreferred) => {
    let updatedAddress = {
      ...address,
      ...form
    }

    updatedAddress.isPreferred = isPreferred
    if (isPreferred) {
      updatedAddress.isInvalid = false
    }

    return updatedAddress
  }

  reconcileAddresses = (originalAddresses = [], form) => {
    const internationalOnshoreStudent = isInternationalOnshoreStudent(form.stuCitizenCd, form.offshoreFlag)
    const skipContactAddress = internationalOnshoreStudent && form.knowsAustralianAddress === "N"

    const contactAddress = originalAddresses.find(({ addressType }) => addressType === AddressType.Contact)
    const newContactAddress = form.contactAddressSameAsPermanentAddress ? (internationalOnshoreStudent && form.knowsAustralianAddress === "Y" ? getContactAddressFields(form) : getPermanentAddressFields(form)) : getContactAddressFields(form)
    
    const isContactAddressPreferred = (!isSameAddress(contactAddress, newContactAddress) || contactAddress.isPreferred) && !skipContactAddress

    // Update any pre-existing addresses coming from Sone
    let updatedAddresses = originalAddresses.map(address => {
      if (address.addressType === AddressType.Semester && address.isPreferred) {
        address.isPreferred = false
      }

      if (address.addressType === AddressType.Contact) {
        if (skipContactAddress) {
          return this.invalidateAddress(address)
        }

        return this.mapToAddress(address, newContactAddress, isContactAddressPreferred)
      }

      if (address.addressType === AddressType.Permanent) {
        return this.mapToAddress(address, getPermanentAddressFields(form), !isContactAddressPreferred)
      }

      return address
    })

    // Create a Permanent address if needed
    const permanentAddress = originalAddresses.find(address => address.addressType === AddressType.Permanent)
    if (!permanentAddress) {
      let permAddress = this.createAddress(AddressType.Permanent, getPermanentAddressFields(form))

      if (skipContactAddress) {
        permAddress.isPreferred = true
      }
      updatedAddresses = updatedAddresses.concat(permAddress)
    }

    // Create a contact address if needed
    const ctctAddress = originalAddresses.find(address => address.addressType === AddressType.Contact)
    if (!ctctAddress && !skipContactAddress) {
      let createdContactAddress = this.createAddress(AddressType.Contact, newContactAddress)
      createdContactAddress.isPreferred = true
      updatedAddresses = updatedAddresses.concat(createdContactAddress)
    }

    return updatedAddresses
  }

  mergeStudentDetails = (studentDetails, countryCodes = []) => {
    let formDetails = {}

    let mobileNumber = studentDetails.phones.find(phone => phone.phoneType == Phone.MOBILE)
    let homeNumber = studentDetails.phones.find(phone => phone.phoneType == Phone.HOME)

    formDetails.mobileNumber = mobileNumber ? `${mobileNumber.phoneNumber}` : ''
    formDetails.homePhoneNumber = homeNumber && !homeNumber.isInvalid ? `${homeNumber.phoneNumber}` : ''

    formDetails.emailAddress = studentDetails.contactPersonalEmail ? studentDetails.contactPersonalEmail : ''

    formDetails.preferredName = studentDetails.preferredName || studentDetails.chosenFirstName || studentDetails.legalFirstName || ''

    formDetails.stuCitizenCd = studentDetails.stuCitizenCd

    const permanentAddress = studentDetails.addresses.find(({ addressType, isInvalid }) => addressType === AddressType.Permanent && !isInvalid)

    if (permanentAddress) {
      formDetails = {
        ...formDetails,
        ...mergePermanentDetails(permanentAddress)
      }
    }
    const contactAddress = studentDetails.addresses.find(({ addressType, isInvalid }) => addressType === AddressType.Contact && !isInvalid)
    
    if (contactAddress) {
      formDetails.knowsAustralianAddress = contactAddress.country === Country.Australia
      formDetails = {
        ...formDetails,
        knowsAustralianAddress: contactAddress.country === Country.Australia ? "Y" : "N",
        ...mergeContactDetails(contactAddress)
      }
    }

    formDetails.contactAddressSameAsPermanentAddress = isSameAddress(permanentAddress, contactAddress)

    formDetails.contactName = studentDetails.emergencyContactName
    formDetails.contactNumber = studentDetails.emergencyContactMobilePhone
    formDetails.contactRelationship = studentDetails.emergencyContactRelationshipCode

    return formDetails
  }

  handleCloseInvalidAddressModal = () => {
    this.setState({
      showInvalidAddressModal: false
    })
  }

  render() {
    const { showConfirmationModal, addressToConfirm, showInvalidAddressModal, form } = this.state
    return (
      <div className="page form form_details">
        <h2>Personal details</h2>

        {!this.state.formLoaded ? (
          <Loading />
        ) : (
          <>
            {showConfirmationModal && addressToConfirm && (
              <ConfirmationModal
                className="modal-lg"
                isOpen={showConfirmationModal}
                title="Address Confirmation"
                handleCloseModal={this.handleCloseModal}
                handleCancel={() => this.handleModalCancel(addressToConfirm.type)}
                handleConfirmation={this.handleModalConfirm}
              >
                <div className="my-20">
                  <p>We noticed that your {addressToConfirm.type} address has not been verified. We found a potential match — can you confirm if the address below is correct?</p>
                  <p>
                    <b>{addressToConfirm.searchResult.address}</b>
                  </p>
                </div>
              </ConfirmationModal>
            )}

            <CustomModal
              className={'modal modal-lg'}
              isOpen={showInvalidAddressModal}
              handleCloseModal={() => this.handleCloseInvalidAddressModal()}
              title={'It seems you have an unverified address.'}
              showConfirmationButton={true}
              buttonText="I understand"
            >
              <div className="my-20">
                <p>
                  Please note that your
                  {form.permanentValidationStatus !== AddressValidationStatus.VALIDATED && form.contactValidationStatus !== AddressValidationStatus.VALIDATED
                    ? ' permanent and contact addresses '
                    : form.permanentValidationStatus !== AddressValidationStatus.VALIDATED
                    ? ' permanent address '
                    : form.contactValidationStatus !== AddressValidationStatus.VALIDATED
                    ? ' contact address '
                    : null}
                  could not be automatically verified. To avoid incorrect information in your student record, please try again using the 'Find Address' field to ensure we can verify your address
                  correctly. If you're unable to find your address, you may still proceed manually with your changes by clicking 'Save' again.
                </p>
              </div>
            </CustomModal>

            <CalloutBox topCallout={this.state.topCallout} data={this.state.prefilledData} />

            <ConfirmDetailsForm
              saving={this.state.saving}
              values={this.state.form}
              autofillAddresses={this.state.personDetails.addresses}
              handleCloseInvalidAddressModal={this.handleCloseInvalidAddressModal}
              showInvalidAddressModal={this.state.showInvalidAddressModal}
              hasAttemptedToSave={this.state.hasAttemptedToSave}
              countryCodes={this.state.countryCodes}
              excludedCountries={this.state.excludedCountries}
              emergencyContactOptions={this.state.emergencyContactOptions}
              handleSubmit={this.handleSubmit}
            />
          </>
          
        )}
      </div>
    )
  }
}

export default withRouter(ConfirmDetails)
